import { BsArrowLeft } from "react-icons/bs";
import { RiArrowRightSLine } from "react-icons/ri";
import img1 from '../../../Assets/case_4.png'
import img2 from '../../../Assets/case_4_1.png'
import img3 from '../../../Assets/case_4_2.png'
import avatar from '../../../Assets/avatar_teste.png'
import * as S from './styles';

export const Agroflow = () => {
  return (
    <S.Wrapper>

      <S.HeaderBar>
        <S.BackButton
          onClick={() => window.history.back()} aria-label="Voltar"
        >
          <BsArrowLeft size={40} />
        </S.BackButton>
        <h2>Agroflow Integrador</h2>
      </S.HeaderBar>

      <S.Grid>
        <S.Sidebar>
          <S.SideBlock>

            <S.SideTitle>
              Overview
            </S.SideTitle>

            <p>
              A Bindflow desenvolveu um hub de integração inteligente entre sistemas ERP e dispositivos IoT — como balanças, PDVs e etiquetadoras —, criando uma ponte fluida entre o mundo físico e o digital.
            </p>

            <p>
              Com essa solução, as informações fluem em tempo real desde a entrada da matéria-prima até a saída do produto, garantindo visibilidade total, redução de erros operacionais e maior produtividade em todas as etapas da cadeia.
            </p>

            <p>
              O resultado é uma operação mais eficiente, automatizada e conectada, que impulsiona o desempenho industrial e comercial, assegurando agilidade e confiabilidade nos processos do dia a dia.
            </p>

          </S.SideBlock>

          <S.SideBlock>
            <S.SideTitle>Entregáveis</S.SideTitle>
            <ul>
              <li><p>Hub de integração entre ERP’s e dispositivos IoT.</p></li>
              <li><p>Comunicação em tempo real entre sistemas e equipamentos.</p></li>
              <li><p>Monitoramento automatizado de dados de produção.</p></li>
              <li><p>Redução de erros e retrabalhos manuais.</p></li>
              <li><p>Aumento da produtividade operacional.</p></li>
              <li><p>Integração modular e escalável para diferentes segmentos.</p></li>
              <li><p>Painel central de gestão e acompanhamento em tempo real.</p></li>
            </ul>
          </S.SideBlock>
        </S.Sidebar>

        <S.Main>
          <S.Img src={img1} alt="Hero" />

          <S.TwoCol>
            <S.Img src={img2} alt="" />
            <S.Img src={img3} alt="" />
          </S.TwoCol>

        </S.Main>
      </S.Grid>
    </S.Wrapper >
  );
};
